import { render, staticRenderFns } from "./List.vue?vue&type=template&id=35c0f963&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=35c0f963&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c0f963",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c0f963')) {
      api.createRecord('35c0f963', component.options)
    } else {
      api.reload('35c0f963', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=35c0f963&scoped=true", function () {
      api.rerender('35c0f963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/role/List.vue"
export default component.exports